import { render, staticRenderFns } from "./Agency.vue?vue&type=template&id=8adc3c72&"
import script from "./agency.js?vue&type=script&lang=js&"
export * from "./agency.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports